import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({ catid, sessionVid, setLoading } = {}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    if (!sessionVid || !setLoading) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/fetch_catogory.php?vid=${sessionVid}&ccatid=${catid}`);
        setData(response);
        
      } catch (error) {
        console.error(error)
      }
      finally{
        setLoading(false);
      }
      
    };
    console.log("dfdsfsdfsfsfsdfsfsfsf");
    if (sessionVid && catid) {
      fetchData();
    }

    fetchData();

  }, [catid, sessionVid, setLoading]);

  return {data};
};

export default useFetchData;